<template>
  <div>
    <form @submit.prevent="newCountry">
      <div class="space-y-4">
        <div>
          <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Country Name</label>
          <input
            type="text"
            v-model="form.name"
            placeholder="Country Name"
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
            required
          />
        </div>
        <div>
          <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Country Code</label>
          <input
            type="text"
            v-model="form.code"
            placeholder="Country code eg. UG, US"
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
            required
          />
        </div>
        <div class="flex justify-end">
          <button
            type="submit"
            :disabled="spinner"
            class="btn-primary"
          >
            <i class="fa-solid fa-save"></i>
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useConfigurationsStore } from "../../../stores";

interface CountryForm {
  name: string | null;
  code: string | null;
}

const store = useConfigurationsStore();
const spinner = ref(false);
const form = ref<CountryForm>({
  name: null,
  code: null
});

const newCountry = () => {
  if (!form.value.name || !form.value.code) {
    return;
  }

  spinner.value = true;
  store.createCountry(form.value);
};

watch(
  () => store.country,
  (country) => {
    if (country) {
      spinner.value = false;
      // @ts-ignore - successToast is injected globally
      window.successToast("Success", "Country created successfully");
      form.value = { name: null, code: null };
      store.fetchCountries();
    }
  }
);

watch(
  () => store.countryError,
  (error) => {
    if (error) {
      spinner.value = false;
      // @ts-ignore - errorToast is injected globally
      window.errorToast("Error", "Creation failed");
    }
  }
);
</script>

